import { Icon } from '@blueprintjs/core';
import { faAngleDoubleDown, faAngleDoubleUp, faMobileAlt, faPhoneAlt, faShuttleVan, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import KeyEventsTable from './keyEventsTable'
import {
  boltTripIdSpan, blockSpan, clientIcon, clientInfoContainer, clientPanelWidth,
  collectSpan, completeWidth, displayBlock, dropOffIcon, flexColumn, fontItalic, fontNormalBold,
  mainSpanStyle, mobilePhoneIconSpan, mobilePhoneIconWidth, widthAuto,
  phoneIcon, phoneIconWidth, pickUpDropOffContainer, pickUpIcon, preferredProviderContainer, providerSpanStyle,
  serviceAndPaxContainer, servicePanelContainer, servicePanelWidth, totalPaySpan, tripDetailPanelDiv,
  tripDetailsColumnContainer, tripMilesSpan, tspSpanWidth,
  pickUpFlexContainer, tripDetailsFlexDiv
} from '../../styles';
import { formatValue, formatNumber, formatPhoneNumber } from '../../../utils/helpers';
import { getDriver, getProvider } from '../../services/providerApiService';

export default class TripDetailTabPanel extends React.Component {

  state = {
    tripNumber: null,
    driverPhone: null,
    providerPhone: null,
  }

  getPurposeCode = (customFields) => {
    var purposeCode = 'purpose code';
    if (customFields !== undefined && customFields != null && customFields.length > 0) {
      return customFields.find(customField => customField.fieldName === purposeCode)?.fieldValue;
    }
    return '';
  }

  setDriverAndProviderPhones = async () => {
    let driverPhone = '';
    let providerPhone = '';

    const promises = [];

    if (this.props.trip.driverId !== undefined && this.props.trip.driverId !== '0') {
      const p1 = getDriver(this.props.trip.driverId).then(driver => driverPhone = driver?.phoneNumber);

      promises.push(p1);
    }

    if (this.props.trip.serviceProviderId !== undefined && this.props.trip.serviceProviderId !== 0) {
      const p2 = getProvider(this.props.trip.serviceProviderId).then(provider => providerPhone = provider?.phoneNumber)

      promises.push(p2);
    }

    await Promise.all(promises);

    await this.setState({
      tripNumber: this.props.trip.tripNumber,
      driverPhone: driverPhone,
      providerPhone: providerPhone,
    })
  }

  componentDidMount = async () => {
    if (this.props.trip !== null) {
      await this.setDriverAndProviderPhones();
    }
  }

  componentDidUpdate = async () => {
    if (this.props.trip !== null && this.props.trip?.tripNumber !== this.state.tripNumber) {
      this.setState({
        tripNumber: this.props.trip.tripNumber,
      })
      await this.setDriverAndProviderPhones();
    }
  }

  render() {
    const trip = this.props.trip;
    var providerName = trip?.preferredProvider ? trip?.preferredProvider.providerName : '';
    var providerTelephone = trip?.preferredProvider ? trip?.preferredProvider.phoneNumber : '';
    const purposeCode = this.getPurposeCode(trip?.customFields);

    return (
      <div style={tripDetailPanelDiv}>
        <div style={pickUpDropOffContainer}>
          <div style={pickUpFlexContainer}>
            <span style={pickUpIcon}><FontAwesomeIcon icon={faAngleDoubleUp} /> Pickup</span>
            <span style={displayBlock}>{formatValue(trip?.pickupAddressLine1)}</span>
            <span style={displayBlock}>{formatValue(trip?.pickupAddressLine2)}</span>
            <span style={displayBlock}>{formatValue(trip?.pickupCity)} {formatValue(trip?.pickupState)} {formatValue(trip?.pickupZip)}</span>
            <span style={phoneIcon}>
              <span style={fontNormalBold}>
                <FontAwesomeIcon icon={faPhoneAlt} />
              </span>
              <a href={"tel:" + formatValue(trip?.pickupPhone)}>{formatPhoneNumber(trip?.pickupPhone)}</a>
            </span>
          </div>
          <div style={completeWidth}>
            <span style={dropOffIcon}><FontAwesomeIcon icon={faAngleDoubleDown} /> Dropoff</span>
            <span style={displayBlock}>{formatValue(trip?.dropoffAddressLine1)}</span>
            <span style={displayBlock}>{formatValue(trip?.dropoffAddressLine2)}</span>
            <span style={displayBlock}>{formatValue(trip?.dropoffCity)} {formatValue(trip?.dropoffState)} {formatValue(trip?.dropoffZip)}</span>
            <span style={phoneIcon}>
              <span style={fontNormalBold}>
                <FontAwesomeIcon icon={faPhoneAlt} />
              </span>
              <a href={"tel:" + formatValue(trip?.dropoffPhone)}>{formatPhoneNumber(trip?.dropoffPhone)}</a>
            </span>
          </div>
        </div>
        <div>
          <span><strong>Purpose: </strong>{formatValue(purposeCode)}</span>
        </div>
        <br />
        <div style={widthAuto}>
          <span style={mainSpanStyle}><FontAwesomeIcon icon={faUser} /> PASSENGER</span>
          <div style={tripDetailsFlexDiv}>
            <span>{formatValue(trip?.passengerFirstName)}&nbsp;{formatValue(trip?.passengerLastName)}</span>
          </div>
          <span style={displayBlock}><strong>ALCID:&nbsp;</strong>{formatValue(trip?.alcPassengerId)}</span>
          <span style={displayBlock}>{trip?.passengerWcCount} WC, {formatValue(trip?.passengerCount)} AMB</span>
          <span style={mobilePhoneIconSpan}>
            <span style={fontNormalBold}><FontAwesomeIcon icon={faMobileAlt} /></span>
            <a href={"tel:" + formatValue(trip?.passengerCellPhone)}>
              {formatPhoneNumber(trip?.passengerCellPhone)}
            </a>
          </span>
          <span style={collectSpan}>
            <strong>Collect:</strong>
            {(trip?.billPassengerMethod?.toLowerCase() === 'cash' ?
              `${Number(trip?.billPassengerAmount).toFixed(2)}` : 'N/A') +
              (trip?.billPassengerMethod !== null && trip?.billPassengerMethod !== '' ? ' - ' : ' ')
              + formatValue(trip?.billPassengerMethod)}
          </span>
        </div>
        <div style={serviceAndPaxContainer}>
          <div style={servicePanelWidth}>

            {!this.props.openTripContainer ? (
              <div className="Service-Vehicle">
                <span style={mainSpanStyle}><FontAwesomeIcon icon={faShuttleVan} /> SERVICE</span>
                <span style={tspSpanWidth}><strong>TSP:</strong> {formatValue(trip?.serviceProviderName)}</span>
                <span style={displayBlock}><strong>Driver:</strong> {formatValue(trip?.driverName)}</span>
                <span style={displayBlock}><strong>Vehicle:</strong> {formatValue(trip?.vehicleColor)} {formatValue(trip?.vehicleMake)} {formatValue(trip?.vehicleModel)} </span>
                <span style={displayBlock}><strong>License Plate:</strong> {trip?.vehicleLicensePlate}</span>
                <span style={providerSpanStyle}>
                  <FontAwesomeIcon icon={faPhoneAlt}
                    style={phoneIconWidth} /> <strong>Provider:</strong>
                  <a style={fontItalic} href={"tel:" + formatValue(this.state.providerPhone)}>
                    {formatPhoneNumber(this.state.providerPhone)}</a></span>
                <span style={displayBlock}><FontAwesomeIcon icon={faMobileAlt}
                  style={mobilePhoneIconWidth} /> <strong>Driver:</strong>
                  <a style={fontItalic} href={"tel:" + formatValue(this.state.driverPhone)}>
                    {formatPhoneNumber(this.state.driverPhone)}</a></span>
              </div>
            ) : (<div className="PreferredProvider">
              <span style={mainSpanStyle}><FontAwesomeIcon icon={faShuttleVan} /> SERVICE</span>
              <div style={preferredProviderContainer}>
                <span style={flexColumn}><strong>Preferred Provider:</strong></span> <span>&nbsp;{formatValue(providerName)}</span>
              </div>
              <span style={providerSpanStyle}>
                <FontAwesomeIcon icon={faPhoneAlt} style={phoneIconWidth} />
                <strong>Provider:</strong>
                <a style={fontItalic} href={"tel:" + formatValue(providerTelephone)}>{formatPhoneNumber(providerTelephone)}
                </a>
              </span>
            </div>)}
          </div>
        </div>

        {!this.props.openTripContainer ? (
          <div style={servicePanelContainer}>
            <div style={servicePanelWidth}>
              <span style={tripMilesSpan}><strong>Trip Miles:</strong> {formatNumber(trip?.tripMiles, 1)}</span>
              <span style={tripMilesSpan}>
                <strong>Total Pay:</strong>
                {trip?.payDriver ? `$${Number(trip?.payDriver).toFixed(2)}` : ''}
              </span>
              <span style={boltTripIdSpan}><strong>Bolt Trip:</strong> {formatValue(trip?.boltTripId)}</span>
            </div>
            <div>
              <div style={clientPanelWidth}>
                <span style={mainSpanStyle}><Icon style={clientIcon} icon={'info-sign'} />Client</span>
                <span style={displayBlock}>{`${formatValue(trip?.clientName)} ${formatValue(trip?.programName)}`}</span>
              </div>
            </div>
          </div>
        ) : (
            <div style={tripDetailsColumnContainer}>
              <div style={servicePanelWidth}>
                <span style={tripMilesSpan}><strong>Trip Miles:</strong> {formatNumber(trip?.tripMiles, 1)}</span>
                <span style={totalPaySpan}>
                  <strong>Total Pay:</strong>
                  {trip?.payDriver ? `$${Number(trip?.payDriver).toFixed(2)}` : ''}
                </span>
                <span style={blockSpan}><strong>Bolt Trip:</strong> {formatValue(trip?.boltTripId)}</span>
              </div>
              <div>
                <div style={clientInfoContainer}>
                  <span style={mainSpanStyle}><Icon style={clientIcon} icon={'info-sign'} />Client</span>
                  <span style={displayBlock}>{`${formatValue(trip?.clientName)} ${formatValue(trip?.programName)}`}</span>
                </div>
              </div>
            </div>
          )}
        {!this.props.openTripContainer && (
          <KeyEventsTable trip={this.props.trip}
            handleLoading={this.props.handleLoading}
            isLoading={this.props.isLoading} />
        )}
      </div >
    )
  }
}
